import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Button, Modal, Row, Col, Form, OverlayTrigger } from "react-bootstrap";
import { MdEdit, MdAddCircle, MdFilterList, MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Tooltip } from '@mui/material';
import loading from "../../assets/images/common/loading.gif";
import AppDataGrid from "../../components/common/AppDataGrid";

const Designation = () => {
    const [designations, setDesignations] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");
    const [showFilterModal, setShowFilterModal] = useState(false);
    const handleCloseFilterModal = () => setShowFilterModal(false);

    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const navigate = useNavigate();
    const userData = sessionStorage.getItem('user');
    const userObj = JSON.parse(userData);
    const [departments, setDepartments] = useState([]);
    const [levels, setLevels] = useState([]);
    const [form, setForm] = useState({
        description: "",
        dept_id: null,
        level_id: null,
        action: "FILTER"
    });

    useEffect(() => {
        setIsLoading(true);
        fetchData().finally(() => setIsLoading(false));
    }, []);

    const handleEditClick = (designation_id) => {
        const employeemasterToEdit = designations.find(
            (designation) => designation.designation_id === designation_id
        );

        if (employeemasterToEdit) {
            navigate("/adddesignation", { state: { designationsData: employeemasterToEdit } });
        } else {
            console.error(`Designation with ID ${designation_id} not found.`);
        }
    };

    const fetchData = async () => {
        try {
            const response = await axios.post(baseUrl + "/designation/", {
                action: "READ",
                school_id: userObj.school_id
            });
            setDesignations(response.data);
        } catch (error) {
            console.log("Error fetching data:", error);
        }
    };

    useEffect(() => {
        // levelData();
        // DepartmentData();
    }, []);

    const handleDeleteClick = async (designation_id) => {
        const confirmDelete = window.confirm('Are you sure you want to change the status?');

        if (!confirmDelete) {
            return;
        }
        const requestBody = {
            designation_id: designation_id,
            action: "DELETE"
        };

        try {
            const response = await axios.post(baseUrl + '/designation/', requestBody, {
                headers: {
                    'Content-Type': 'application/json'
                },
            });
            if (response.status < 200 || response.status >= 300) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            toast.success("Record Set To InActive ");
            fetchData();
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const fetchDropdownData = async (endpoint, setter) => {
        try {
            const response = await axios.post(baseUrl + endpoint, {
                action: 'READ',
                school_id: userObj.school_id
            });
            setter(response.data);
        } catch (error) {
            console.error(`Error fetching ${endpoint}:`, error);
        }
    };

    const handleShowFilterModal = () => {
        if (departments.length === 0) {
            fetchDropdownData('/department/', setDepartments, userObj.school_id);
        }
        if (levels.length === 0) {
            fetchDropdownData('/level/', setLevels, userObj.school_id);
        }

        setShowFilterModal(true);
    };

    const searchableColumns = [
        (row) => row.description,
        (row) => row.is_active,
        (row) => row.dept_name,
        (row) => row.level_name
    ];

    const normalizedQuery = (searchQuery || '')
        .toLowerCase()
        .replace(/[-\s]+/g, '');

    const filteredRecords = (designations || []).filter((item) =>
        searchableColumns.some((selector) => {
            const value = selector(item);
            const stringValue = String(value || '')
                .toLowerCase()
                .replace(/[-\s]+/g, '');
            return stringValue.includes(normalizedQuery);
        })
    );

    const canSubmit = true; // define this based on your condition or user permissions

    const columns = [
        {
            field: "description",
            headerName: "Designation Name",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "dept_name",
            headerName: "Department Name",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "level_name",
            headerName: "Level Name",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "is_active",
            headerName: "Status",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        ...(canSubmit
            ? [
                {
                    field: "actions",
                    headerName: "Actions",
                    flex: 1,
                    sortable: false,
                    renderCell: (params) =>
                        params.row.level_name !== "No records found" ? (
                            <div className="tableActions">
                                <Tooltip title="Edit" arrow>
                                    <span
                                        className="commonActionIcons"
                                        onClick={() => handleEditClick(params.row.designation_id)}
                                    >
                                        <MdEdit />
                                    </span>
                                </Tooltip>
                                <Tooltip title="Delete" arrow>
                                    <span
                                        className="commonActionIcons"
                                        onClick={() => handleDeleteClick(params.row.designation_id)}
                                    >
                                        <MdDelete />
                                    </span>
                                </Tooltip>
                            </div>
                        ) : null,
                },
            ]
            : []),
    ];

    const handleInputChange = (e) => {
        const { id, value } = e.target;

        setForm((prevForm) => ({
            ...prevForm,
            [id]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = {
            dept_id: form.dept_id,
            is_active: form.is_active || "A",
            school_id: userObj.school_id,
            level_id: form.level_id,
            description: form.description,
            action: 'FILTER',
        };

        try {
            const response = await axios.post(baseUrl + "/designation/", formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const data = response.data;

            if (data && typeof data === "object" && data.message === "No data found for action: FILTER") {
                setDesignations([]);
            } else {
                setDesignations(data);
            }

            setShowFilterModal(false);
        } catch (error) {
            console.error("Error during filtering:", error);
            setDesignations([]);
            setShowFilterModal(false);
        }
    };

    const handleReset = async (e) => {
        e.preventDefault();
        setForm({
            description: "",
            level_id: "",
            dept_id: ""
        });
        setShowFilterModal(true);
        fetchData();
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    return (
        <div className="pageBody">
            <ToastContainer />
            <div className="commonDataTableHead">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                        <h6 className="commonTableTitle">Designation Master</h6>
                    </div>
                    <div className="">
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            className="searchInput"
                            onChange={handleSearchChange}
                        />
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: 6 }}>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}>
                            <Button className="secondaryBtn" variant="secondary" onClick={handleShowFilterModal}>
                                <MdFilterList />
                            </Button>
                        </OverlayTrigger>
                        {
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Add</Tooltip>}>
                                <Button
                                    className="primaryBtn"
                                    variant="primary"
                                    onClick={() => navigate("/adddesignation")}
                                >
                                    <MdAddCircle />
                                </Button>
                            </OverlayTrigger>
                        }
                    </div>
                </div>
            </div>

            <div className="commonTable height100">
                <div className="tableBody">
                    {isLoading ? (
                        <div className="loadingContainer">
                            <img src={loading} alt="Loading..." className="loadingGif" />
                        </div>
                    ) : (
                        <AppDataGrid
                            // ✅ Let DataGrid show its own "No rows" state
                            rows={filteredRecords}
                            columns={columns}
                            getRowId={(row) => row.designation_id}
                            showToolbar={false}
                            pagination
                            pageSizeOptions={[10, 20, 50]}
                            density="compact"
                            maxHeight={550}
                        />
                    )}
                </div>
            </div>

            <Modal show={showFilterModal} onHide={handleCloseFilterModal} className="commonFilterModal">
                <Modal.Header closeButton className="modalHeaderFixed">
                    <Modal.Title>Filter</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modalBodyScrollable">
                    <Row>
                        <Col xs={12}>
                            <div className='commonInput'>
                                <Form.Group controlId="firstName">
                                    <Form.Label> Designation Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="description"
                                        value={form.description}
                                        placeholder="Enter Designation Name"
                                        onChange={handleInputChange}
                                        onKeyDown={(e) => {
                                            if (e.key === ' ' && e.target.selectionStart === 0) {
                                                e.preventDefault();
                                            }
                                        }}
                                        maxLength={30}
                                    />
                                </Form.Group>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <div className='commonInput'>
                                <Form.Group controlId="month_name">
                                    <Form.Label>Department</Form.Label>
                                    <Form.Select
                                        name="dept_id"
                                        id="dept_id"
                                        value={form.dept_id}
                                        onChange={(e) =>
                                            setForm({ ...form, dept_id: e.target.value })
                                        }
                                    >
                                        <option value="" disabled hidden>
                                            Select Department
                                        </option>
                                        {(departments || [])
                                            .filter((department) => department.is_active === "Active")
                                            .map((department) => (
                                                <option key={department.dept_id} value={department.dept_id}>
                                                    {department.dept_name}
                                                </option>
                                            ))}
                                    </Form.Select>
                                </Form.Group>
                            </div>
                        </Col>

                        <Col xs={12}>
                            <div className='commonInput'>
                                <Form.Group controlId="month_name">
                                    <Form.Label>Level Name</Form.Label>
                                    <Form.Select
                                        name="dept_id"
                                        id="dept_id"
                                        value={form.level_id}
                                        onChange={(e) =>
                                            setForm({ ...form, level_id: e.target.value })
                                        }
                                    >
                                        <option value="" disabled hidden>
                                            Select Level Name
                                        </option>
                                        {(levels || [])
                                            .filter((level) => level.is_active === "Active")
                                            .map((level) => (
                                                <option key={levels.level_id} value={level.level_id}>
                                                    {level.description}
                                                </option>
                                            ))}
                                    </Form.Select>
                                </Form.Group>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="modalFooterFixed">
                    <Button
                        variant="secondary"
                        className="btn-info clearBtn me-2"
                        onClick={handleReset}
                    >
                        Reset
                    </Button>
                    <div>
                        <Button
                            variant="secondary"
                            className="btn-danger secondaryBtn me-2"
                            onClick={() => {
                                handleCloseFilterModal();
                            }}
                        >
                            Cancel
                        </Button>

                        <Button
                            variant="primary"
                            className="btn-success primaryBtn"
                            onClick={handleSubmit}
                        >
                            Search
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Designation;
